import cloudbase from '@cloudbase/js-sdk';

// 初始化云开发环境
const app = cloudbase.init({
  env: 'mdymp-9g2g8g6r76405598',
  region: 'ap-shanghai',
  signMethod: process.env.REACT_APP_TCB_SIGN_METHOD || 'TC3-HMAC-SHA256'
});

// 导出云开发实例
export const cloud = app;

// 导出匿名登录方法
export const anonymousLogin = async () => {
  try {
    const auth =app.auth();
    await auth.signInAnonymously();
    // console.log('匿名登录成功',auth.currentUser);
    return auth.currentUser;
  } catch (err) {
    // console.error('匿名登录失败', err.code,err.message);
    throw err;
  }
};

// 导出云函数调用方法
export const callFunction = async (name, data) => {
  try {
    // 确保先进行匿名登录
    await anonymousLogin();
    
    // 获取访问令牌
    const accessToken = localStorage.getItem('access_token');
    
    // 准备请求数据
    const params = {
      name,
      data: {
        ...data,
        // 将访问令牌添加到请求数据中
        token: accessToken // 修改这里，使用 token 作为键名
      }
    };

    const result = await cloud.callFunction(params);
    return result.result;
  } catch (error) {
    throw error;
  }
};